export const getCroppedImage = (imageSrc: string, pixelCrop: { x: number; y: number; width: number; height: number }): Promise<string> => {
    return new Promise((resolve) => {
        const image = new Image();
        image.src = imageSrc;
        image.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
  
            const maxWidth = 228;
            const maxHeight = 286;
  
            // Устанавливаем размеры холста в соответствии с максимальными значениями
            canvas.width = maxWidth
            canvas.height = maxHeight
  
            if (ctx) {
                // Создаем овальную маску
                ctx.beginPath();
                ctx.ellipse(
                    canvas.width / 2,
                    canvas.height / 2,
                    canvas.width / 2,  
                    canvas.height / 2, 
                    0,
                    0,
                    Math.PI * 2
                );
                ctx.closePath();
                ctx.clip();
  
                // Вычисляем коэффициенты масштабирования
                const scaleX = canvas.width / pixelCrop.width;
                const scaleY = canvas.height / pixelCrop.height;
  
                // Рисуем изображение с учетом масштабирования
                ctx.drawImage(
                    image,
                    pixelCrop.x,
                    pixelCrop.y,
                    pixelCrop.width,
                    pixelCrop.height,
                    0,
                    0,
                    pixelCrop.width * scaleX,
                    pixelCrop.height * scaleY
                );
  
                // Создаем Data URL из canvas в формате PNG
                const base64Image = canvas.toDataURL('image/png'); // Используем формат PNG
                resolve(base64Image);
            }
        };
    });
  };

// export const getCroppedImage = (imageSrc: string, pixelCrop: { x: number; y: number; width: number; height: number }, rotation: number): Promise<string> => {
//     return new Promise((resolve) => {
//         const image = new Image();
//         image.src = imageSrc;
//         image.onload = () => {
//             const canvas = document.createElement('canvas');
//             const ctx = canvas.getContext('2d');

//             const maxWidth = 228;
//             const maxHeight = 286;

//             // Устанавливаем размеры холста
//             canvas.width = maxWidth;
//             canvas.height = maxHeight;

//             if (ctx) {
//                 // Сохраняем контекст и применяем поворот
//                 ctx.save();
//                 ctx.translate(canvas.width / 2, canvas.height / 2); // Поворачиваем вокруг центра холста
//                 ctx.rotate((rotation * Math.PI) / 180); // Поворачиваем в радианах
//                 ctx.translate(-canvas.width / 2, -canvas.height / 2); // Возвращаемся обратно

//                 // Создаем овальную маску
//                 ctx.beginPath();
//                 ctx.ellipse(
//                     canvas.width / 2,
//                     canvas.height / 2,
//                     canvas.width / 2,
//                     canvas.height / 2,
//                     0,
//                     0,
//                     Math.PI * 2
//                 );
//                 ctx.closePath();
//                 ctx.clip();

//                 // Вычисляем коэффициенты масштабирования
//                 const scaleX = canvas.width / pixelCrop.width;
//                 const scaleY = canvas.height / pixelCrop.height;

//                 // Корректируем координаты обрезки
//                 const adjustedX = pixelCrop.x * scaleX;
//                 const adjustedY = pixelCrop.y * scaleY;

//                 // Рисуем изображение с учетом масштабирования и обрезки
//                 ctx.drawImage(
//                     image,
//                     adjustedX,
//                     adjustedY,
//                     pixelCrop.width * scaleX,
//                     pixelCrop.height * scaleY,
//                     0,
//                     0,
//                     pixelCrop.width * scaleX,
//                     pixelCrop.height * scaleY
//                 );

//                 ctx.restore(); // Восстанавливаем контекст после поворота

//                 // Создаем Data URL из canvas в формате PNG
//                 const base64Image = canvas.toDataURL('image/png'); // Используем формат PNG
//                 resolve(base64Image);
//             }
//         };
//     });
// };

